import * as types from './index';

export const donorFormSubmitAction = (donor) => {
  return {
    type: types.DONOR_SUBMIT,
    donor
  }
};

export const updateDonorAction = (donor) => {
  return {
    type: types.DONOR_UPDATE,
    donor
  }
};

export const selfserviceDonorAction = (donor) => {
  return {
    type: types.DONOR_SELFSERVICE,
    donor
  }
};

export const notifyDonorsAction = (notifyPayload) => {
  return {
    type: types.NOTIFY_DONORS,
    notifyPayload
  }
};

export const allDonorsFetchAction = (payload) => {
  return {
    type: types.ALL_DONORS_FETCH,
    payload
  }
};

export const fetchDonorByPhoneAction = (payload) => {
  return {
    type: types.DONOR_FETCHBYPHONE,
    payload
  }
};

export const addVolunteerDonorAction = (payload) => {
  return {
    type: types.ADD_VOLUNTEER_DONOR,
    payload
  }
};

export const deleteVolunteerDonorAction = (payload) => {
  return {
    type: types.DELETE_VOLUNTEER_DONOR,
    payload
  }
};

export const importDonorAction = (payload) => {
  return {
    type: types.IMPORT_DONORS,
    payload
  }
};

export const sendDonorOTPAction = (payload) => {
  return {
    type: types.SEND_OTP_DONOR,
    payload
  }
};

export const addActualDonorAction = (payload) => {
  return {
    type: types.ADD_ACTUAL_DONOR,
    payload
  }
};